import { makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  // No margin: unlike the market-visibility marker, it sits flush in the adornment slot.
  trigger: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  tooltip: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  }
})

export default useStyles
